import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import Header from './layout/Header';
import Translate from './layout/Translate';
import {Track, TrackedDiv, TrackDocument} from 'react-track';
import {tween, combine} from 'react-imation';
import {rotate} from 'react-imation/tween-value-factories';
import * as userActions from '../actions/user';
import {
	topTop,
	topBottom,
	centerCenter,
	topCenter,
	bottomBottom,
	bottomTop,
	getDocumentRect,
	getDocumentElement,
	calculateScrollY
} from 'react-track/tracking-formulas';
import ReactPlayer from 'react-player'

var Scroll = require('react-scroll');


var ScrollLink = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var ScrollElement = Scroll.Element;
var ScrollEvents = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;
var scroller = Scroll.scroller;

class About extends Component {
	componentDidUpdate(_prevProps, _prevState) {

	}

	componentWillMount () {
		this.screenHeight = 1000;
		this.lastScrollPos = 0;
		this.direction = 1;

		this.speedConfig = [
			700, 1000, 700, 1000, 700, 1000, 700
		];


	}

	componentDidMount () {


		this.pageWidth = ReactDOM.findDOMNode(this.refs.main).clientWidth;
		if (this.pageWidth < 1000) {
			this.isMobile = true;
		}

		if (!this.isMobile) {
			let obj = this;
			setTimeout(function(){
				obj.props.userActions.showAboutVideo();
			}, 5000);
		}

	}

	componentWillUpdate() {

	}


	handleScroll(scrollY, topTop, topBottom) {
		let object = this;


		this.screenHeight = -topBottom;
		if(this.lastScrollPos > scrollY) {
			//console.log('top');
			this.direction = -1;
		} else if(this.lastScrollPos < scrollY) {
			this.direction = 1;
			//console.log('bottom');
		}
		this.lastScrollPos = scrollY;

		this.offset = this.lastScrollPos % this.screenHeight;
		this.screen = Math.floor(this.lastScrollPos / this.screenHeight);


		if (this.wheel) {

			if (this.offset > 0 && this.direction == 1 && this.currentScreen != this.screen+1) {
				this.currentScreen = this.screen+1;

				object.scrolling = true;

				scroller.scrollTo('section' + (this.screen+1), {
					duration: object.speedConfig[this.screen],
					delay: 0,
					smooth: true
				});

				//e.preventDefault();
			} else if (this.offset <  this.screenHeight && this.direction == -1 && this.currentScreen != this.screen) {

				object.scrolling = true;
				this.currentScreen = this.screen;
				scroller.scrollTo('section' + (this.screen), {
					duration: object.speedConfig[this.screen],
					delay: 0,
					smooth: true
				});
			}
		}

		ScrollEvents.scrollEvent.register('end', function(to, element) {
			//console.log("end", to, element);
		});
		object.scrolling = false;

		this.wheel = false;

	}

	handleWheel(e) {
		if (this.props.user.showAboutVideo) {
			let obj = this;
			//	const ele = ReactDOM.findDOMNode(this.refs.departures);
			if (!this.scrolling) {
				e.stopPropagation();
				this.wheel = true;

				setTimeout(function(){
					obj.scrolling = false;
					obj.wheel = false;
				}, 400);
			}
		} else {
			e.stopPropagation();
		}
	}

	selectMeaning(index) {
		this.props.userActions.selectMeaning(index);
	}


	forceScreenScroll(e) {
		if (this.props.user.showAboutVideo) {
			scroller.scrollTo('section' + (this.screen + 1), {
				duration: 500,
				delay: 0,
				smooth: true
			});
		}
	}

	toggleVideo() {
		this.props.userActions.toggleVideo();
	}

	closeVideo() {
		this.props.userActions.toggleVideo();

		scroller.scrollTo('section' + 1, {
			duration: 500,
			delay: 0,
			smooth: true
		});
	}


	testHandle(e) {
		//console.log('SCROLL')
	}

  render() {
	  let isMobile = this.isMobile;
    return (


		<div style={{background: '#fff', position: 'relative', zIndex: 100}} ref="main">
			<TrackDocument formulas={[getDocumentElement, getDocumentRect, calculateScrollY,
								   topTop, topBottom, topCenter, centerCenter, bottomBottom,
								   bottomTop]}>
				{(documentElement, documentRect, scrollY, topTop,
				  topBottom, topCenter, centerCenter, bottomBottom, bottomTop) =>
					<div className={isMobile?'about_mobile':''} onWheel={this.handleWheel.bind(this)}>
					<Header fixed={(!isMobile?true:false)}  absolute={(isMobile?true:false)} />
						<div className={"popup popup_video " + (this.props.user.videoOpen?'popup_active':'')}>
							{this.props.user.lang == 'ru' &&
								<ReactPlayer url='https://vimeo.com/196250419' className="popup__video" vimeoConfig={{preload: true}} playing={this.props.user.videoOpen} />
							}
							{this.props.user.lang != 'ru' &&
								<ReactPlayer url='https://vimeo.com/196250002' className="popup__video" vimeoConfig={{preload: true}} playing={this.props.user.videoOpen} />
							}
							<div className="video__close" onClick={this.closeVideo.bind(this)}></div>
						</div>
						<ScrollElement name="section0">
							<Track component="section" formulas={[topTop, topBottom, centerCenter, bottomTop]} name="">
									{(SECTION, posTopTop, posTopBottom, posCenterCenter, posBottomTop) =>
										<SECTION className={" section " + this.handleScroll((isMobile?0:scrollY), posTopTop, posTopBottom)}>
											<div className={" about about_0 about_first " + (((isMobile?0:scrollY)<posBottomTop+this.screenHeight)?'about_visible ':'') + (!(isMobile?0:scrollY)?' about_init':'')}
												 style={tween((isMobile?0:scrollY), [
											  [  0, { opacity: 1 } ],
											  [  posBottomTop, { opacity: 1 } ],
											  [ posBottomTop+this.screenHeight, { opacity: 0 } ]
											  ])}>
												{!isMobile &&
													<div className={"pg-bar pg-bar_absolute"}>
														<div className={"pg-bar__line pg-bar__line_progress"}></div>
													</div>
												}
												<div className="about__container about__container_title"
													 style={tween((isMobile?0:scrollY), [
											  [  posTopTop, { opacity: 1 } ],
											  [ posBottomTop, { opacity: 0 } ]
											  ])}>
													<h1 onClick={this.toggleVideo.bind(this)}><Translate slug="about__meet-the-nature" /></h1>
													<div className="about__show-video" onClick={this.toggleVideo.bind(this)}><Translate slug="about__show-video" /></div>
												</div>
												<video playsInline autoPlay muted loop className={"about__video " + (this.props.user.showAboutVideo?"about__video_visible":"")} id="video" ref="video" >
													<source src="/static/about_us.mp4" type="video/mp4" />
												</video>

												{!isMobile &&
													<div
														className={"about__mouse mouse " + (!this.props.user.showAboutVideo?"mouse_hidden":"")}
														onClick={this.forceScreenScroll.bind(this)}
														style={tween((isMobile?0:scrollY), [
														  [  posTopTop, { opacity: 1 } ],
														  [ posBottomTop, { opacity: 0 } ]
														  ])}>
														<div className="mouse__icon"></div>
														<div className="mouse__text"><Translate slug="about__skip-video"/>
														</div>
													</div>
												}
											</div>
										</SECTION>
									}
							</Track>
					</ScrollElement>
						<ScrollElement name="section1">
							<Track component="section" formulas={[topTop, topBottom, centerCenter, bottomTop]} name="">
								{(SECTION, posTopTop, posTopBottom, posCenterCenter, posBottomTop) =>
									<SECTION className="section  " name=""
									>

										<div className={"about  about_1 " + ((!!(isMobile?0:scrollY) && (isMobile?0:scrollY)>(posTopTop+100-this.screenHeight) && (isMobile?0:scrollY)<posBottomTop+this.screenHeight)?'about_visible':'') + (!(isMobile?0:scrollY)?' about_init':'')}
											 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight), { opacity: 1 } ],
											  [  posTopTop, { opacity: 1 } ]
											  ])}>

											<div className="about__background"
												 style={tween((isMobile?0:scrollY), [
											  [  0, { top: 1000 } ],
												  [  posTopTop - (this.screenHeight), {opacity: 0, top: this.screenHeight } ],
												  [  posTopTop, { opacity: 1, top: 0, height: this.screenHeight } ],
												  [  posTopTop+this.screenHeight/2, { opacity: 1, top: -this.screenHeight, height: this.screenHeight*2 } ]
											  ])}>
												<div className="about__shape about_bg_11"></div>
												<div className="about__white-bg"></div>
											</div>

											<div className="about__container"
												 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/13)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posTopTop+this.screenHeight/2, { opacity: 0 } ]
											  ])}>
												<h2><Translate slug="about__title_1" /></h2>
												<div className="about__text">
													<Translate slug="about__text_1" />
												</div>
											</div>
											{!isMobile &&
												<div className="about__mouse mouse" onClick={this.forceScreenScroll.bind(this)}
													 style={tween((isMobile?0:scrollY), [
												  [  posTopTop - (this.screenHeight*(1/13)), { opacity: 0 } ],
												  [  posTopTop, { opacity: 1 } ],
												  [ posBottomTop, { opacity: 0 } ]
												  ])}>
													<div className="mouse__icon mouse__icon_black"></div>

														<div className="mouse__text mouse__text_black"><Translate
															slug="about__next"/></div>
												</div>
											}
										</div>
									</SECTION>
								}
								</Track>
						</ScrollElement>
							<ScrollElement name="section2">
								<Track component="section" formulas={[topTop, topBottom, centerCenter, bottomTop]} name="">
									{(SECTION, posTopTop, posTopBottom, posCenterCenter, posBottomTop) =>
					<SECTION className="section "  name="">

						<div className={"about about_2 about_bg_02 " + (((isMobile?0:scrollY) && (isMobile?0:scrollY)>(posTopTop+100-this.screenHeight) && (isMobile?0:scrollY)<posBottomTop+this.screenHeight)?'about_visible':'') + (!(isMobile?0:scrollY)?' about_init':'')}
							 style={tween((isMobile?0:scrollY), [
											  [  0, { opacity: 0 } ],
											  [  posTopTop - (this.screenHeight/2), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posBottomTop, { opacity: 1 } ]
											  ])}>
							<div className="about__container"
								 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/4)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posTopTop + (this.screenHeight*(1/2)), { opacity: 0 } ]
											  ])}>
								<h2 className="about__title_white"><Translate slug="about__title_2" /></h2>
								<div className="about__text about__text_white">
									<Translate slug="about__text_2" />
								</div>
							</div>
							{!isMobile &&
							<div className="about__mouse mouse" onClick={this.forceScreenScroll.bind(this)}
								 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/4)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posBottomTop, { opacity: 0 } ]
											  ])}>
								<div className="mouse__icon"></div>
									<div className="mouse__text"><Translate slug="about__next"/></div>
							</div>
							}
						</div>
					</SECTION>
									}
								</Track>
							</ScrollElement>
								<ScrollElement name="section3">
										<Track component="section" formulas={[topTop, topBottom, centerCenter, bottomTop]} name="">
									{(SECTION, posTopTop, posTopBottom, posCenterCenter, posBottomTop) =>
					<SECTION className="section"  name="">

						<div className={"about about_3 " + (((isMobile?0:scrollY) && (isMobile?0:scrollY)>(posTopTop+100-this.screenHeight) && (isMobile?0:scrollY)<posBottomTop+this.screenHeight)?'about_visible':'') + (!(isMobile?0:scrollY)?' about_init':'')}
							 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight), { opacity: 1 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posBottomTop, { opacity: 1 } ]
											  ])}>
							<div className="about__background  "
								 style={tween((isMobile?0:scrollY), [
											  [  0, { top: 1000 } ],
												  [  posTopTop - (this.screenHeight), {opacity: 0, top: this.screenHeight } ],
												  [  posTopTop, { opacity: 1, top: 0, height: this.screenHeight } ],
												  [  posTopTop+this.screenHeight/2, { opacity: 1, top: -this.screenHeight, height: this.screenHeight*2 } ]
											  ])}>
								<div className="about__shape about_bg_12"></div>
								<div className="about__white-bg"></div>
							</div>
							<div className="about__container"
								 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/12)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posTopTop + this.screenHeight/2, { opacity: 0 } ]
											  ])}>
								<h2><Translate slug="about__title_3" /></h2>
								<div className="about__text">
									<Translate slug="about__text_3" />
								</div>
							</div>
							{!isMobile &&
							<div className="about__mouse mouse" onClick={this.forceScreenScroll.bind(this)}
								 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/13)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posBottomTop, { opacity: 0 } ]
											  ])}>
								<div className="mouse__icon mouse__icon_black"></div>
									<div className="mouse__text mouse__text_black"><Translate slug="about__next"/></div>
							</div>
							}
						</div>
					</SECTION>
									}
										</Track>
								</ScrollElement>
									<ScrollElement name="section4">
										<Track component="section" formulas={[topTop, topBottom, centerCenter, bottomTop]} name="">
									{(SECTION, posTopTop, posTopBottom, posCenterCenter, posBottomTop) =>
					<SECTION className="section "  name="">

						<div className={"about about_4 about_bg_03 " + (((isMobile?0:scrollY) && (isMobile?0:scrollY)>(posTopTop+100-this.screenHeight) && (isMobile?0:scrollY)<posBottomTop+this.screenHeight)?'about_visible':'') + (!(isMobile?0:scrollY)?' about_init':'')}
							 style={tween((isMobile?0:scrollY), [
											  [  0, { opacity: 0 } ],
											  [  posTopTop - (this.screenHeight/2), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ]
											  ])}>
							<div className="about__container"
								 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/4)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posTopTop + (this.screenHeight*(1/4)), { opacity: 0 } ]
											  ])}>
								<h2 className="about__title_white"><Translate slug="about__title_4" /></h2>
								<div className="about__text about__text_white">
									<Translate slug="about__text_4" />
								</div>
						</div>
							{!isMobile &&
							<div className="about__mouse mouse" onClick={this.forceScreenScroll.bind(this)}
								 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/4)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posBottomTop, { opacity: 0 } ]
											  ])}>
								<div className="mouse__icon "></div>

									<div className="mouse__text "><Translate slug="about__next"/></div>
							</div>
							}
						</div>
					</SECTION>
									}
										</Track>
									</ScrollElement>

						<ScrollElement name="section5">
							<Track component="section" formulas={[topTop, topBottom, centerCenter, bottomTop]} name="">
								{(SECTION, posTopTop, posTopBottom, posCenterCenter, posBottomTop) =>
									<SECTION className="section  " name=""
									>
										<div className={"about about_5 about_4 " + (((isMobile?0:scrollY) && (isMobile?0:scrollY)>(posTopTop+100-this.screenHeight) && (isMobile?0:scrollY)<posBottomTop+this.screenHeight)?'about_visible':'') + (!(isMobile?0:scrollY)?' about_init':'')}
											 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight), { opacity: 1 } ],
											  [  posTopTop, { opacity: 1 } ]
											  ])}>
											<div className="about__background "
												 style={tween((isMobile?0:scrollY), [
											  [  0, { top: 1000 } ],
												  [  posTopTop - (this.screenHeight), {opacity: 0, top: this.screenHeight } ],
												  [  posTopTop, { opacity: 1, top: 0, height: this.screenHeight } ],
												  [  posTopTop+this.screenHeight/2, { opacity: 1, top: -this.screenHeight, height: this.screenHeight*2 } ]
											  ])}>
												<div className="about__shape about_bg_13"></div>
												<div className="about__white-bg"></div>
											</div>

											<div className="about__container"
												 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/13)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posBottomTop, { opacity: 0 } ]
											  ])}>
												<h2><Translate slug="about__title_5" /></h2>
												<div className="about__text">
													<Translate slug="about__text_5" />
												</div>
											</div>

											{!isMobile &&
											<div className="about__mouse mouse" onClick={this.forceScreenScroll.bind(this)}
												 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/13)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ],
											  [ posTopTop + this.screenHeight/2, { opacity: 0 } ]
											  ])}>
												<div className="mouse__icon mouse__icon_black"></div>
													<div className="mouse__text mouse__text_black"><Translate slug="about__next"/></div>
											</div>
											}
										</div>
									</SECTION>
								}
							</Track>
						</ScrollElement>
											<ScrollElement name="section6">
										<Track component="section" formulas={[topTop, topBottom, centerCenter, bottomTop]} name="">
									{(SECTION, posTopTop, posTopBottom, posCenterCenter, posBottomTop) =>
					<SECTION className="section "  name="">
						<div className={"about about_6 about_bg_04 " + (((isMobile?0:scrollY) && (isMobile?0:scrollY)>(posTopTop+100-this.screenHeight) && (isMobile?0:scrollY)<posBottomTop+this.screenHeight)?'about_visible':'') + (!(isMobile?0:scrollY)?' about_init':'')}
							 style={tween((isMobile?0:scrollY), [
											  [  0, { opacity: 0 } ],
											  [  posTopTop - (this.screenHeight), { opacity: 0 } ],
											  [ posTopTop - (this.screenHeight*(1/2)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ]
											  ])}>
							<div className="about__container about__container_top"
								 style={tween((isMobile?0:scrollY), [
											  [  posTopTop - (this.screenHeight*(1/4)), { opacity: 0 } ],
											  [  posTopTop, { opacity: 1 } ]
											  ])}>
								<h2 className="about__title_white"><Translate slug="about__title_6" /></h2>
								<div className="about__text about__text_white">
									<Translate slug="about__text_6" />
								</div>
								<ul className="about__list">
									<li className={"about__item " + ((!this.props.user.meaningIndex)?'about__item_active':'')} onClick={this.selectMeaning.bind(this, 0)}><Translate slug="about__list__title_1" /></li>
									<li className={"about__item " + ((this.props.user.meaningIndex==1)?'about__item_active':'')} onClick={this.selectMeaning.bind(this, 1)}><Translate slug="about__list__title_2" /></li>
									<li className={"about__item " + ((this.props.user.meaningIndex==2)?'about__item_active':'')} onClick={this.selectMeaning.bind(this, 2)}><Translate slug="about__list__title_3" /></li>
									<li className={"about__item " + ((this.props.user.meaningIndex==3)?'about__item_active':'')} onClick={this.selectMeaning.bind(this, 3)}><Translate slug="about__list__title_4" /></li>
									<li className={"about__item " + ((this.props.user.meaningIndex==4)?'about__item_active':'')} onClick={this.selectMeaning.bind(this, 4)}><Translate slug="about__list__title_5" /></li>
									<li className={"about__item " + ((this.props.user.meaningIndex==5)?'about__item_active':'')} onClick={this.selectMeaning.bind(this, 5)}><Translate slug="about__list__title_6" /></li>
								</ul>
								<div className={"about__text about__text_white about__text_optional " + ((!this.props.user.meaningIndex)?'about__text_active':'')}>
									<Translate slug="about__list__text_1" />
								</div>
								<div className={"about__text about__text_white about__text_optional "  + ((this.props.user.meaningIndex==1)?'about__text_active':'')}>
									<Translate slug="about__list__text_2" />
								</div>
								<div className={"about__text about__text_white about__text_optional "  + ((this.props.user.meaningIndex==2)?'about__text_active':'')}>
									<Translate slug="about__list__text_3" />
								</div>
								<div className={"about__text about__text_white about__text_optional "  + ((this.props.user.meaningIndex==3)?'about__text_active':'')}>
									<Translate slug="about__list__text_4" />
								</div>
								<div className={"about__text about__text_white about__text_optional "  + ((this.props.user.meaningIndex==4)?'about__text_active':'')}>
									<Translate slug="about__list__text_5" />
								</div>
								<div className={"about__text about__text_white about__text_optional "  + ((this.props.user.meaningIndex==5)?'about__text_active':'')}>
									<Translate slug="about__list__text_6" />
								</div>
							</div>
							{isMobile && 
								<div className="footer__registration footer__registration_about">
									<Translate
										slug="main__registration"/>
								</div>
							}
						</div>
					</SECTION>
									}
										</Track>
											</ScrollElement>
				</div>
				}
			</TrackDocument>
		</div>
  
    );
  }
}


function mapStateToProps(state) {
	return {
		user : state.user
	};
}


function mapDispatchToProps(dispatch) {
	return {
		userActions: bindActionCreators(userActions, dispatch)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(About);



// WEBPACK FOOTER //
// ./src/common/components/About.js